module.exports = __webpack_public_path__ + "img/1080_04.b6043910.jpg";